/* ============================================================
   FLAVORPIX™ HERO — assets/fp-hero.js
   ------------------------------------------------------------
   - Lazy autoplay vidéo (économise data sur mobile/slow network)
   - Marque la vidéo "ready" pour fade-in propre
   - Smooth scroll vers les ancres (CTA + scroll hint)
   - Pause vidéo quand hors viewport (économie ressources)
   ============================================================ */

(function () {
  'use strict';

  const heroes = document.querySelectorAll('[data-fp-hero]');
  if (!heroes.length) return;

  heroes.forEach(initHero);

  function initHero(hero) {
    const video = hero.querySelector('[data-fp-hero-video]');
    const ctaPrimary = hero.querySelector('[data-fp-cta-primary]');
    const scrollHint = hero.querySelector('.fp-hero__scroll-hint');

    // ===================================================
    // 1. Gestion vidéo : conditions pour autoplay
    // ===================================================
    if (video) {
      const shouldPlay = canAutoplayVideo();

      if (!shouldPlay) {
        // Mobile faible débit ou data-saving → pas de vidéo
        hero.setAttribute('data-no-video', '');
        video.removeAttribute('autoplay');
      } else {
        // Vidéo OK → on attend qu'elle joue vraiment pour révéler
        const markReady = () => hero.setAttribute('data-video-ready', '');
        if (video.readyState >= 3) {
          markReady();
        } else {
          video.addEventListener('canplay', markReady, { once: true });
          // Fallback : si la vidéo ne charge jamais, on laisse le poster
          setTimeout(() => {
            if (!hero.hasAttribute('data-video-ready')) {
              hero.setAttribute('data-no-video', '');
            }
          }, 4000);
        }

        // Force play (Safari iOS est strict sur autoplay)
        video.play().catch(() => {
          // L'utilisateur a un browser qui bloque l'autoplay → on garde le poster
          hero.setAttribute('data-no-video', '');
        });
      }

      // Pause hors viewport (économise GPU/batterie)
      if ('IntersectionObserver' in window) {
        const visObs = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.1 }
        );
        visObs.observe(hero);
      }
    }

    // ===================================================
    // 2. Smooth scroll pour CTA primaire et scroll hint
    // ===================================================
    [ctaPrimary, scrollHint].forEach((el) => {
      if (!el) return;
      el.addEventListener('click', (e) => {
        const href = el.getAttribute('href');
        if (!href || !href.startsWith('#')) return;
        const target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          block: 'start',
        });
      });
    });
  }

  // ===================================================
  // Helpers
  // ===================================================

  function canAutoplayVideo() {
    // Refus si user préfère reduced motion
    if (prefersReducedMotion()) return false;

    // Refus si data-saver actif
    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn) {
      if (conn.saveData) return false;
      // 2G ou slow-2g = pas de vidéo
      if (conn.effectiveType && /^([23]g|slow-2g)$/i.test(conn.effectiveType)) return false;
    }

    return true;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
})();
